import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/Skills.css";

export const Skills = () => {
  const strengths = [
    { icon: "⚡", title: "Product Speed", text: "I ship fast without breaking UX—tight loops, CI-ready code, clean releases." },
    { icon: "🧭", title: "End-to-End Ownership", text: "Idea → prod: Flutter apps, Laravel APIs, React dashboards, sane DevOps." },
    { icon: "🧠", title: "Architecture Choices", text: "Right state mgmt (BLoC/GetX/Provider) + clear API contracts." },
  ];

  const core = [
    { name: "Flutter", level: "Expert" },
    { name: "Dart", level: "Expert" },
    { name: "Firebase (Auth/FCM/Firestore)", level: "Advanced" },
    { name: "REST API Integration", level: "Advanced" },
    { name: "Push & Local Notifications", level: "Advanced" },
    { name: "Google Maps SDK", level: "Advanced" },
    { name: "GetX (Flutter)", level: "Advanced" },
    { name: "Provider (Flutter)", level: "Proficient" },
  ];

  const stateMgmt = [
    { name: "Laravel (API Design)", level: "Advanced" },
    { name: "React Web Application", level: "Expert" },
    { name: "React JS API implementation", level: "Expert" },
    { name: "Server management", level: "Proficient" },
    { name: "Database Design & Security Basics", level: "Proficient" },
    { name: "Controller Based (React JS)", level: "Proficient" },
    { name: "MVCS (Laravel)", level: "Proficient" },
  ];



  const levelToBadge = (lvl) => {
    switch (lvl) {
      case "Expert": return { text: "Expert Level", variant: "success" };
      case "Advanced": return { text: "Experienced (6+ yrs)", variant: "primary" };
      case "Proficient": return { text: "Mid-level", variant: "info" };
      default: return { text: "Contributor", variant: "secondary" };
    }
  };

  const SkillList = ({ title, badgeText, items }) => (
    <Card className="skill-card h-100">
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <Card.Title className="text-primary">{title}</Card.Title>
          {badgeText && <Badge bg="dark">{badgeText}</Badge>}
        </div>
        <ul className="skill-list">
          {items.map((s) => {
            const b = levelToBadge(s.level);
            return (
              <li key={s.name} className="skill-row">
                <span className="text-primary">{s.name}</span>
                <Badge bg={b.variant} pill>{b.text}</Badge>
              </li>
            );
          })}
        </ul>
      </Card.Body>
    </Card>
  );

  // NEW: What I Offer — clear value bullets
  const offers = [
    { icon: "📱", text: "Android app from design → build → Play Store launch (Flutter, CI/CD, release signing)." },
    { icon: "🗃️", text: "Database schema design → secure Laravel APIs → versioned docs (auth, rate limits, logs)." },
    { icon: "🖥️", text: "React web apps & admin dashboards that stay fast and simple under scale." },
    { icon: "🚀", text: "Solo full-system launch: infra, environment setup, HTTPS, monitoring, backups." },
    { icon: "🧪", text: "Quality pipeline: crash analytics, error tracking, staged rollouts, post-release fixes." },
    { icon: "🧩", text: "Idea → MVP scoping: feature prioritization, roadmap, and go-to-market friendly UX." },
  ];

  return (
    <section id="skills" className="skills-section">
      <Container>
        {/* strengths */}
        <Row className="g-3 mb-5">
          {strengths.map((s) => (
            <Col key={s.title} md={4}>
              <Card className="strength-card h-100">
                <Card.Body>
                  <div className="strength-icon" aria-hidden>{s.icon}</div>
                  <Card.Title className="text-primary">{s.title}</Card.Title>
                  <Card.Text className="text-secondary">{s.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* skill groups */}
        <Row className="g-4">
          <Col md={6}><SkillList title="Core Mobile" badgeText="Flutter First" items={core} /></Col>
          <Col md={6}><SkillList title="Web & Backend" items={stateMgmt} /></Col>

          <Col md={12}>
            <Card className="skill-card">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <Card.Title className="text-primary">What my skills offer</Card.Title>
                  <Badge bg="warning" text="dark">APIs + Dashboards</Badge>
                </div>
                <ul className="offer-list">
                  {offers.map((o, idx) => (
                    <li key={idx} className="offer-item">
                      <span className="offer-icon" aria-hidden>{o.icon}</span>
                      <span className="offer-text">{o.text}</span>
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
